<div class="container">
  <mc-prescription-form></mc-prescription-form>
</div>
